<template>
  <PaymentRequestsForHireTable :hire-id="props.hireId" />
</template>

<script lang="ts" setup>
import PaymentRequestsForHireTable from '@/components/PaymentRequests/Client/PaymentRequestsForHireTable.vue'

const props = defineProps<{
  hireId: string
}>()
</script>

